import React, { Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "redux"
import styled, { keyframes } from "styled-components"
import { translate } from "react-i18next"
import { lighten } from "polished"
import tada from "react-animations/lib/tada"

const animation = keyframes`${tada}`

const Icon = styled.i`
  animation: 1s ${animation};
  color: ${prop => lighten(0.3, prop.color)};
  font-size: 4em;
`

const IconContainer = styled.div`
  text-align: center;
  margin: 20px 0;
`

const MessageContainer = styled.div`
  text-align: center;
`

const Header = styled.h3`
  color: ${prop => prop.color};
`

// eslint-disable-next-line react/prop-types
function EmptyDashboardMessage({ t, theme }) {
  return (
    <Fragment>
      <IconContainer className="col-sm-12">
        <Icon color={theme.primaryColor} className="fa fa-thumbs-o-down fa-3x" aria-hidden="true" />
      </IconContainer>
      <MessageContainer className="col-sm-12">
        <Header color={theme.primaryColor}>{t("Dashboards.EmptyState.Header")}</Header>
        <p>
          {t("Dashboards.EmptyState.MessageLine1")}
          <br />
          {t("Dashboards.EmptyState.MessageLine2")}
        </p>
      </MessageContainer>
    </Fragment>
  )
}

function mapStateToProps(state) {
  return {
    theme: state.userDetail.theme,
  }
}

export default compose(translate(), connect(mapStateToProps))(EmptyDashboardMessage)



// WEBPACK FOOTER //
// ./src/components/EmptyDashboardMessage.jsx